import { useCallback, useEffect, useState } from "react";
import Table from "../../../../common/components/table-manager/v1.1/table";
import { globalDbnTaxonomyCategories } from "../../../../redux/global-dbn-taxonomy-categories/action";
import { useAppDispatch } from "../../../../hooks/hooks";

export const GlobalDbnTaxonomyCompareCategories = ({ data, onClose }: any) => {
  const dispatch = useAppDispatch()
  const [selectedCategories, setSelectedCategories] = useState<any>(null);
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [compareColumnDefs, setCompareColumnDefs] = useState({});

  const createCompareColumnDefs: any = () => {
    setCompareColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', sortable: true, filter: true, filterType: 'text', },
      { field: 'IsSubCategory', headerName: 'Sub Category', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
      { field: 'ParentCategory', headerName: 'Parent Category', sortable: true, filter: true, filterType: 'text' },
      { field: 'DomainName', headerName: 'Domain Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'Code', headerName: 'Code', sortable: true, filter: true, filterType: 'text', }
    ]);
  }

  const createCategories = async (data: any) => {
    await dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'create' }))
    await dispatch(globalDbnTaxonomyCategories.create({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories`,
      entity: 'globalDbnTaxonomyCategories',
      jsonData:
      {
        Context: {},
        Records: data
      }
    }))
  }

  const handleFormSubmit = () => {
    if (selectedCategories) {
      createCategories(selectedCategories)
    }
    onClose()
  }

  const handleSelectMemoized = useCallback((data: any) => {
    setSelectedCategories(prev => {
      if (JSON.stringify(prev) !== JSON.stringify(data)) {
        return data; // Only update if different
      }
      return prev; // Avoid unnecessary updates
    });
  }, [selectedCategories]); // Add dependency

  useEffect(() => {
    createCompareColumnDefs();
  }, []);

  return (
    <>
      <div className="min-w-[800px]">
        <Table
          columnData={compareColumnDefs}
          rowData={data?.result}
          enableFilter={true}
          onSelect={handleSelectMemoized}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={data?.result?.pagination}
          // onSearch={handleSearch}
          // searchCriteriaList={searchCriteriaList}
          // onEdit={handleEdit}
          // onDelete={handleDelete}
          // additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Code',
          }}
          headingName="Categories comparison result"
        />
        <div className='flex w-full justify-end items-end'>
          <button
            onClick={onClose}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          >
            Close
          </button>
          <button
            className={`m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 ${!selectedCategories || selectedCategories?.length === 0 ? 'bg-gray-400' : 'bg-blue-700'}  `}
            onClick={handleFormSubmit}
            disabled={!selectedCategories || selectedCategories?.length === 0}
            type="submit"
          >
            Import Selected Categories
          </button>
        </div>
      </div>
    </>
  )
}

export default GlobalDbnTaxonomyCompareCategories;


